(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["announcement-bar"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-ab-terms-open]');
    if (opener) {
      var dlg = document.getElementById('ab-terms-' + opener.getAttribute('data-ab-terms-open'));
      if (dlg && typeof dlg.showModal === 'function' && !dlg.open) dlg.showModal();
      return;
    }
    var closer = e.target.closest('[data-ab-terms-close]');
    if (closer) {
      var d = closer.closest('dialog');
      if (d) d.close();
      return;
    }
    if (e.target.matches && e.target.matches('dialog.ab-terms')) e.target.close();
  });
  } catch(e) { console.error(e); }
})();

})();
